
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32-.021C14.315-.021-.021 14.315-.021 32c0 17.685 14.336 32.021 32.021 32.021S64.021 49.685 64.021 32C64.021 14.315 49.685-.021 32-.021zm21.437 37.383H10.875V27.259h42.562v10.103z"}})])
          )
        }
      }
    